import * as React from 'react';

export const PersonalCard = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.0996 8C21.0996 5.99357 20.8271 5.10051 20.3633 4.63672C19.8995 4.17293 19.0064 3.90039 17 3.90039H7C4.99357 3.90039 4.10051 4.17293 3.63672 4.63672C3.17293 5.10051 2.90039 5.99357 2.90039 8V16C2.90039 18.0064 3.17293 18.8995 3.63672 19.3633C4.10051 19.8271 4.99357 20.0996 7 20.0996H17C19.0064 20.0996 19.8995 19.8271 20.3633 19.3633C20.8271 18.8995 21.0996 18.0064 21.0996 16V8ZM22.9004 16C22.9004 17.9936 22.6729 19.6005 21.6367 20.6367C20.6005 21.6729 18.9936 21.9004 17 21.9004H7C5.00643 21.9004 3.39949 21.6729 2.36328 20.6367C1.32707 19.6005 1.09961 17.9936 1.09961 16V8C1.09961 6.00643 1.32707 4.39949 2.36328 3.36328C3.39949 2.32707 5.00643 2.09961 7 2.09961H17C18.9936 2.09961 20.6005 2.32708 21.6367 3.36328C22.6729 4.39949 22.9004 6.00643 22.9004 8V16Z"
      fill="#64748B"
    />
    <path
      d="M19 7.09961C19.4971 7.09961 19.9004 7.50294 19.9004 8C19.9004 8.49706 19.4971 8.90039 19 8.90039H14C13.5029 8.90039 13.0996 8.49706 13.0996 8C13.0996 7.50294 13.5029 7.09961 14 7.09961H19Z"
      fill="#64748B"
    />
    <path
      d="M19 11.0996C19.4971 11.0996 19.9004 11.5029 19.9004 12C19.9004 12.4971 19.4971 12.9004 19 12.9004H15C14.5029 12.9004 14.0996 12.4971 14.0996 12C14.0996 11.5029 14.5029 11.0996 15 11.0996H19Z"
      fill="#64748B"
    />
    <path
      d="M19 15.0996C19.4971 15.0996 19.9004 15.5029 19.9004 16C19.9004 16.4971 19.4971 16.9004 19 16.9004H17C16.5029 16.9004 16.0996 16.4971 16.0996 16C16.0996 15.5029 16.5029 15.0996 17 15.0996H19Z"
      fill="#64748B"
    />
    <path
      d="M9.40967 9.47949C9.40944 8.97711 9.00195 8.57031 8.49951 8.57031C7.99727 8.57054 7.59056 8.97725 7.59033 9.47949C7.59033 9.98193 7.99713 10.3894 8.49951 10.3896C9.00209 10.3896 9.40967 9.98207 9.40967 9.47949ZM11.2095 9.47949C11.2095 10.9762 9.9962 12.1895 8.49951 12.1895C7.00302 12.1892 5.78955 10.976 5.78955 9.47949C5.78978 7.98314 7.00316 6.76976 8.49951 6.76953C9.99606 6.76953 11.2092 7.983 11.2095 9.47949Z"
      fill="#64748B"
    />
    <path
      d="M7.65243 12.7142C8.21692 12.6589 8.78296 12.6592 9.33993 12.7142C11.2204 12.8828 12.7139 14.3619 12.8956 16.2435C12.9433 16.7382 12.5815 17.178 12.087 17.226C11.5922 17.2737 11.1523 16.9111 11.1046 16.4164C11.0062 15.3982 10.1991 14.5976 9.17977 14.5062L9.17098 14.5053C8.7312 14.4613 8.2803 14.4619 7.82821 14.5062H7.82625C6.79714 14.6058 5.99351 15.4033 5.89559 16.4164C5.84782 16.9111 5.40792 17.2737 4.91317 17.226C4.41863 17.178 4.05682 16.7382 4.10457 16.2435C4.28675 14.3574 5.7824 12.8964 7.65243 12.7152V12.7142Z"
      fill="#64748B"
    />
  </svg>
);
